module.exports = __webpack_public_path__ + "static/img/eyes_01.458f63f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyes/thumbnail/eyes_01.png
// module id = g/MN
// module chunks = 0